import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';
import {
  SpecialOptionValueConfig,
  SpecialValueKey
} from 'src/app/form-template/form-template-model';

@Component({
  selector: 'csi-text-input-with-special-option',
  templateUrl: './text-input-with-special-option.component.html',
  styleUrls: ['./text-input-with-special-option.component.scss']
})
export class TextInputWithSpecialOptionComponent implements OnInit, OnDestroy {
  @Input() control: FormControl;
  @Input() label: string = '';
  @Input() specialOptions: { [key in SpecialValueKey]?: SpecialOptionValueConfig } = {};

  specialOptionsFormGroup: FormGroup = new FormGroup({});

  constructor() {}

  ngOnInit() {
    if (this.specialOptions) {
      Object.keys(this.specialOptions).forEach(key => {
        this.specialOptionsFormGroup.addControl(key, new FormControl());
      });

      if (this.specialOptionsFormGroup.controls[SpecialValueKey.NONE]) {
        this.specialOptionsFormGroup.controls[SpecialValueKey.NONE].valueChanges
          .pipe(untilDestroyed(this))
          .subscribe(selected => {
            this.control.patchValue(selected ? 'None' : '');
          });
      }
    }
  }
  ngOnDestroy(): void {}
}
